export default __webpack_public_path__ + "static/media/Img0030.1982f570.png";